module.exports = __webpack_public_path__ + "img/flounce_width.87c1a5d6.png";